<template>
    <div class="row ml-1 mr-1">
        <div class="input-group mb-3 col-2">
            <i class="fas fa-calendar-days icon bg-soft-primary text-primary rounded-circle"></i>
            <input id="pickdate" name="date" autocomplete="off" class="form-control" />
        </div>
        <div class="col-3 d-flex p-2">
            <h4>
                <change-employee-inline :employee="employee" :lead_employee_id="lead_employee_id" employeelink="1" />
            </h4>
        </div>
        <div class="col p-3">
            {{ $trans.get("__JSON__.show deleted") }}
            <input type="checkbox" v-model="showDeleted" />
        </div>
        <div class="col d-flex justify-content-end p-2">
            <add-absence v-if="canedit" :employee_id="employee_id" :hr="hr" @saved="newAbsence"
                :selecteddate="varday" />

            <button type="button" class="ml-2 btn btn-primary" @click="addstamp">
                {{ $trans.get("__JSON__.Add stamp") }}
            </button>
        </div>
    </div>
    <div class="row ml-1 mr-1">
        <table class="table">
            <thead>
                <tr>
                    <th>{{ $trans.get("__JSON__.Project") }}</th>
                    <th>{{ $trans.get("__JSON__.Subproject") }}</th>
                    <th></th>
                    <th>{{ $trans.get("__JSON__.Location") }}</th>
                    <th>{{ $trans.get("__JSON__.Start") }}</th>
                    <th>{{ $trans.get("__JSON__.End") }}</th>
                    <th>{{ $trans.get("__JSON__.Lastchange") }}</th>
                    <th>{{ $trans.get("__JSON__.Actions") }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(s, index) in filteredStamps" @blur.capture="handleRowBlur($event, index, 'saved')" :class="{'table-danger': s.deleted_at, 'table-warning': (s.project_id == 0 || hasError('employee_id', s) || hasError('intime', s) || hasError('outtime', s) )}">
                    <td :data-id="s.id">
                        <div class="input-group">
                            <div v-tooltip class="input-group-prepend" v-if="hasError('employee_id', s)"
                                :title="getError('employee_id', s)">
                                <i class="fas fa-exclamation text-danger input-group-text"></i>
                            </div>
                            <select class="form-control" v-model="s.project_id" name="project_id" :id="'project_id-' + index"
                                @change="changeInRow(index, 'saved')" :class="{ 'text-danger': s.project_id == 0 }" @focusin="autofillField('project', s)"
                                :disabled="s.deleted_at || s.read_only || (s.absence && s.is_break == 0) || (!canedit && !s.from_manual_time_tracking)">
                                <option value="0" selected>Choose project</option>
                                <option v-for="item in projects" :key="item.id" :value="item.id"
                                    :disabled="(item.absence_type_id && item.absence_type_id > 0) || item.archived == 1">
                                    {{ item.client != null ? item.client.name : "?" }} - {{ item.name }} {{
                                        (item.archived
                                            == 0) ? '' : " (Archived)"
                                    }}
                                </option>
                            </select>
                        </div>
                    </td>
                    <td>
                        <select v-if="subprojectcount(s) > 0" class="form-control" v-model="s.subproject_id"
                            name="subproject_id" :id="'subproject_id-' + index" @change="changeInRow(index, 'saved')"
                            :class="{ 'text-danger': s.subproject_id == 0 }"
                            :disabled="s.deleted_at || s.read_only || (s.absence && s.is_break == 0) || (!canedit && !s.from_manual_time_tracking)">
                            <option value="0" selected>Choose subproject</option>
                            <option v-for="item in getSubprojects(s)" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <i v-if="s.preperation" v-tooltip :title="$trans.get('__JSON__.preparation and follow-up')"
                            class="fa-solid fa-person-walking">
                        </i>
                    </td>
                    <td>
                        <select class="form-control" v-model="s.location_id" name="location_id" :id="'location_id-' + index"
                            @change="changeInRow(index, 'saved')" :class="{ 'text-danger': s.location_id == 0 }" @focusin="autofillField('location', s)"
                            :disabled="s.deleted_at || s.read_only || (s.absence && s.is_break == 0) || (!canedit && !s.from_manual_time_tracking)"
                            v-if="s.read_only == 0">
                            <option value="0" selected>Choose location</option>
                            <option v-for="item in locations" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <div class="input-group">
                            <div v-tooltip class="input-group-prepend" v-if="hasError('intime', s)"
                                :title="getError('intime', s)">
                                <i class="fas fa-exclamation text-danger input-group-text"></i>
                            </div>
                            <input :id="'intime-' + index" type="datetime-local" class="form-control" v-model="s.intime"
                                @blur="changeInRow(index, 'saved')" :class="{ 'text-danger': hasError('intime', s) }" @focusin="autofillField('intime', s)"
                                :disabled="s.deleted_at || s.read_only || (s.absence && s.is_break == 0) || (!canedit && !s.from_manual_time_tracking)" />
                        </div>
                    </td>
                    <td>
                        <div class="input-group">
                            <div v-tooltip class="input-group-prepend" v-if="hasError('outtime', s)"
                                :title="getError('outtime', s)">
                                <i class="fas fa-exclamation text-danger input-group-text"></i>
                            </div>
                            <input :id="'outtime-' + index" type="datetime-local" class="form-control" v-model="s.outtime"
                                @blur="changeInRow(index, 'saved')" @focusin="autofillField('outtime', s)" :class="{
                                    'text-danger': s.intime > s.outtime || s.outtime == null || hasError('outtime', s),
                                }"
                                :disabled="s.deleted_at || s.read_only || (s.absence && s.is_break == 0) || (!canedit && !s.from_manual_time_tracking)" />
                        </div>
                    </td>
                    <td>
                        <button v-if="s.changename" class="btn btn-sm" @click="history(index)" v-tooltip
                            :title="s.device?.location_detail">{{ s.changename }}
                        </button>
                    </td>
                    <td>
                        <i v-if="!s.deleted_at && (
                            (can('readonly-stamps-delete') && s.absence_id) || s.read_only == 0 && (s.absence == 0 || (s.is_break == 1 && s.absence == 1)) && (canedit || s.from_manual_time_tracking)
                            )"
                            class="fas fa-trash text-primary" @click="deleted(index, 'saved')"></i>
                        <i v-if="s.from_manual_time_tracking" class="ml-1 fas fa-comment text-primary"
                            @click="showComment(index, 'saved')"></i>
                    </td>
                </tr>

                <tr v-for="(s, index) in unsavedList" @blur.capture="handleRowBlur($event, index, 'unsaved')" class="table-warning">
                    <td>
                        <div class="input-group">
                            <div v-tooltip class="input-group-prepend" v-if="hasError('employee_id', s)"
                                :title="getError('employee_id', s)">
                                <i class="fas fa-exclamation text-danger input-group-text"></i>
                            </div>
                            <select class="form-control" v-model="s.project_id" name="project_id" :id="'project_id_u-' + index"
                                :class="{ 'text-danger': s.project_id == 0 }"
                                :disabled="s.deleted_at != null || s.read_only || (s.absence && s.is_break == 0) || (!canedit && !s.from_manual_time_tracking)">
                                <option value="0" selected>Choose project</option>
                                <option v-for="item in s.filteredProjects" :key="item.id" :value="item.id"
                                    :disabled="item.absence_type_id && item.absence_type_id > 0">
                                    {{ item.client != null ? item.client.name : "?" }} - {{ item.name }} {{
                                        (item.archived
                                            == 0) ? '' : " (Archived)"
                                    }}
                                </option>
                            </select>
                        </div>
                    </td>
                    <td>
                        <select v-if="s.subprojectcount > 0" class="form-control" v-model="s.subproject_id"
                            name="subproject_id" :id="'subproject_id_u-' + index"
                            :class="{ 'text-danger': s.subproject_id == 0 }"
                            :disabled="s.deleted_at || s.read_only || (s.absence && s.is_break == 0) || (!canedit && !s.from_manual_time_tracking)">
                            <option value="0" selected>Choose subproject</option>
                            <option v-for="item in s.subprojects" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <i v-if="s.preperation" v-tooltip :title="$trans.get('__JSON__.preparation and follow-up')"
                            class="fa-solid fa-person-walking">
                        </i>
                    </td>
                    <td>
                        <select class="form-control" v-model="s.location_id" name="location_id" :id="'location_id_u-' + index"
                            :class="{ 'text-danger': s.location_id == 0 }"
                            :disabled="s.deleted_at || s.read_only || (s.absence && s.is_break == 0) || (!canedit && !s.from_manual_time_tracking)"
                            v-if="s.read_only == 0">
                            <option value="0" selected>Choose location</option>
                            <option v-for="item in s.locations" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <div class="input-group">
                            <div v-tooltip class="input-group-prepend" v-if="hasError('intime', s)"
                                :title="getError('intime', s)">
                                <i class="fas fa-exclamation text-danger input-group-text"></i>
                            </div>
                            <input :id="'intime_u-' +  index" type="datetime-local" class="form-control" v-model="s.intime"
                                :class="{ 'text-danger': hasError('intime', s) }"
                                :disabled="s.deleted_at || s.read_only || (s.absence && s.is_break == 0) || (!canedit && !s.from_manual_time_tracking)" />
                        </div>
                    </td>
                    <td>
                        <div class="input-group">
                            <div v-tooltip class="input-group-prepend" v-if="hasError('outtime', s)"
                                :title="getError('outtime', s)">
                                <i class="fas fa-exclamation text-danger input-group-text"></i>
                            </div>
                            <input :id="'outtime_u-' + index" type="datetime-local" class="form-control" v-model="s.outtime" @focusin="autofillField('outtime', s)"
                                :class="{
                                    'text-danger': s.intime > s.outtime || s.outtime == null || hasError('outtime', s),
                                }"
                                :disabled="s.deleted_at || s.read_only || (s.absence && s.is_break == 0) || (!canedit && !s.from_manual_time_tracking)" />
                        </div>
                    </td>
                    <td class="align-middle">
                        <span class="badge text-bg-warning ms-2">{{ $trans.get("__JSON__.Unsaved") }}</span>
                    </td>
                    <td>
                        <i v-if="s.deleted_at && s.read_only == 0 && s.absence != 1 && !(!canedit && !s.from_manual_time_tracking)"
                            class="fas fa-trash text-primary" @click="deleted(index, 'unsaved')"></i>
                        <i v-if="s.from_manual_time_tracking" class="ml-1 fas fa-comment text-primary"
                            @click="showComment(index, 'unsaved')"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="modal" tabindex="-1" id="changemodal">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $trans.get("__JSON__.Changes") }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <history v-if="stamphistory" :changes="stamphistory" :locations="locations" :projects="projects" :clients="clients" :teams="teams">
                    </history>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        {{ $trans.get("__JSON__.Close") }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <Teleport to="body">
        <div class="modal" tabindex="-1" id="showManualTimeTrackingComment">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-body">
                        <textarea class="form-control mb-3" v-model="commentstamp.comment_from_manual"></textarea>
                        <span class="btn btn-light" @click.stop="saveComment">Speichern</span>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import axios from "axios";
import { formatDateTime, formatDateTimeWithSeconds } from "../formatdate";
import { v4 as uuidv4 } from 'uuid';

export default {
    name: "EmployeeStamps",
    created() {
        this.varday = this.day;
        this.fetchProjects(true);
    },
    props: {
        day: String,
        employee_id: String,
        hr: String,
        canedit: Number,
        clients: Array,
        lead_employee_id: null,
        teams: Array,
        week: null,
    },
    data() {
        return {
            stamps: null,
            projects: null,
            locations: null,
            picker: null,
            varday: null,
            employee: {
                lastname: null,
                forename: null,
            },
            stamphistory: null,
            unsavedList: [],
            commentstamp: { comment_from_manual: '' },
            showDeleted: false,
            employeeshift: null
        };
    },
    mounted() {
        this.picker = datepicker("#pickdate", {
            onSelect: (instance, date) => {
                this.varday = this.formatDate(date);
                this.fetchData();
                this.fetchEmployeeShift();
            },
            dateSelected: new Date(this.day),
            formatter: (input, date, instance) => {
                input.value = this.formatDate(date);
            },
            startDay: 1,
        });

        this.fetchProjects();
        this.fetchLocations();
        this.fetchEmployeeShift();

        this.varday = this.formatDate(new Date(this.day));

    },
    computed: {
        actualProject() {
            if (!this.absenceprojects) {
                return null;
            }

            return this.absenceprojects.find(
                (item) => item.id == this.absenceproject_id
            );
        },
        filteredStamps() {
            if (this.showDeleted) {
                return this.stamps;
            }
            else {
                return this.stamps?.filter((item) => {
                    return item.deleted_at == null;
                });
            }
        }
    },
    methods: {
        deleted(index, list) {
            if (confirm("Are you sure you want to delete the stamp?")) {
                if (list == 'saved') {
                    axios
                        .delete("/api/stamps/" + this.filteredStamps[index].id)
                        .then((resp) => {
                            this.fetchData();
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                } else {
                    this.unsavedList.splice(index, 1);
                }
            }
        },
        getSubprojects(stamp = null) {
            if (this.projects && stamp) {
                const project = this.projects.find((item) => {
                    return item.id == stamp.project_id;
                });

                if (project) {
                    return project.subprojects;
                }
            }
        },
        subprojectcount(stamp = null) {
            if (this.projects && stamp) {
                const project = this.projects.find((item) => {
                    return item.id == stamp.project_id;
                });

                if (project) {
                    return project.subprojects?.length;
                }
            }
            return 0;
        },
        trySaveAllUnsaved() {
            this.unsavedList.forEach((stamp, index) => {
                axios
                    .post("/api/stamps", stamp)
                    .then((resp) => {
                        this.unsavedList = this.unsavedList.filter((item) => {
                            return item.uuid != stamp.uuid;
                        });
                        this.fetchData();
                    })
                    .catch((error) => {
                        console.log('error.response.data', error.response.data);
                        this.s.errors = error.response.data;
                    });
            });
        },
        changeInRow(index, list) {
            if (list == 'saved') {
                var stamp = this.filteredStamps[index];
            } else {
                var stamp = this.unsavedList[index];
            }

            if (stamp.id) {
                // console.log(stamp.deleted_at);
                // if (!stamp.deleted_at) {
                    axios
                        .put("/api/stamps/" + stamp.id, stamp)
                        .then((resp) => {
                            if (list == 'saved') {
                                this.trySaveAllUnsaved();
                                this.fetchData();
                            }
                        })
                        .catch((error) => {
                            if (list == 'saved') {
                                this.filteredStamps[index].errors = error.response.data;
                            } else {
                                this.unsavedList[index].errors = error.response.data;
                            }
                        });
                // }
            } else {
                axios
                    .post("/api/stamps", stamp)
                    .then((resp) => {
                        this.unsavedList.splice(index, 1);
                        this.fetchData();
                    })
                    .catch((error) => {
                        if (list == 'saved') {
                            this.stamps[index].errors = error.response.data;
                        } else {
                            this.unsavedList[index].errors = error.response.data;
                        }
                    });
            }
        },
        hasError(field, s) {
            if (s.hasOwnProperty("errors")) {
                if (field in s.errors.errors) {
                    return true;
                }
            }
            return false;
        },
        formatDate(date) {
            return date.getFullYear() +
                "-" +
                this.pad(date.getMonth() + 1, 2) +
                "-" +
                this.pad(date.getDate(), 2);
        },
        updateInChildren(data) {
            this.unsavedList[data.index] = data.stamp;
        },
        fetchFilteredProjects(stamp = null) {
            if (this.projects) {
                return this.projects.filter((item) => {
                    return item.archived == false || (stamp ? item.id == stamp.project_id : null);
                });
            }
        },
        fetchData() {
            axios
                .get("/api/employees/" + this.employee_id + "/stamps", {
                    params: {
                        day: this.varday,
                    },
                })
                .then((resp) => {
                    this.stamps = resp.data;
                    this.stamps.forEach((stamp, sindex) => {
                        this.stamps[sindex].intime = formatDateTime(stamp.intime);
                        this.stamps[sindex].outtime = formatDateTime(stamp.outtime);
                        delete this.stamps[sindex].original_in_at;
                        delete this.stamps[sindex].original_out_at;
                        // this.stamps[sindex].original_in_at = formatDateTimeWithSeconds(stamp.original_in_at);
                        // this.stamps[sindex].original_out_at = formatDateTimeWithSeconds(stamp.original_out_at);
                        //this.stamps[sindex].filteredProjects = this.fetchFilteredProjects(stamp);
                        //this.stamps[sindex].locations = this.locations;
                        //this.stamps[sindex].subprojects = this.getSubprojects(stamp);
                        //this.stamps[sindex].subprojectcount = this.subprojectcount(stamp);
                    });
                    //console.log(this.stamps);
                })
                .catch((error) => {
                    console.log(error);
                });

            axios
                .get("/api/employees/" + this.employee_id)
                .then((resp) => {
                    this.employee = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        fetchProjects(initial = false) {
            axios
                .get("/api/projects/all", {})
                .then((resp) => {
                    this.projects = resp.data;
                    if (initial) {
                        this.fetchLocations(initial);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        fetchLocations(initial = true) {
            axios
                .get("/api/locations", {})
                .then((resp) => {
                    this.locations = resp.data;
                    if (initial) {
                        this.fetchData();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        locationClick(event) {
            console.log(event);
        },
        history(index) {
            var stampId = this.filteredStamps[index]?.id;
            console.log(stampId);
            var stamp = this.stamps.find((item) => item.id === stampId);
            console.log(stamp);
            axios
                .get("/api/history", {
                    params: {
                        reference_table: "App\\Models\\Stamp",
                        reference_id: stamp.id,
                    },
                })
                .then((resp) => {
                    this.stamphistory = resp.data;
                    $("#changemodal").modal("show");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        compare(a, b) {
            if (a.intime < b.intime) {
                return -1;
            }
            if (a.intime > b.intime) {
                return 1;
            }
            return 0;
        },
        pad(num, size) {
            var s = "000000000" + num;
            return s.substr(s.length - size);
        },
        addstamp() {
            const newstamp = {
                id: null,
                device_id: 0,
                location_id: 0,
                project_id: 0,
                employee_id: this.employee_id,
                intime: null,
                outtime: null,
                read_only: false,
                from_manual_time_tracking: this.canedit ? false : true,
                from_manual_time_tracking_list: true,
                comment_from_manual: '',
                save: false,
                saved: true,
                filteredProjects: this.fetchFilteredProjects(null),
                locations: this.locations,
                subprojects: this.getSubprojects(null),
                subprojectcount: this.subprojectcount(null),
                uuid: uuidv4(),
                deleted_at: null,
            };
            this.unsavedList.push(newstamp);
            this.autofill(newstamp);
        },
        getError(field, s) {
            if (s.hasOwnProperty("errors")) {
                if (field in s.errors.errors) {
                    return s.errors.errors[field];
                }
            }
            return "";
        },
        showComment(index, list) {
            if (list == 'saved') {
                this.commentstamp = this.stamps[index];
            } else {
                this.commentstamp = this.unsavedList[index];
            }
            $("#showManualTimeTrackingComment").modal("show");
        },
        saveComment() {
            axios
                .put("/api/stamps/" + this.commentstamp.id, this.commentstamp)
                .then((resp) => {
                    $("#showManualTimeTrackingComment").modal("hide");
                })
                .catch((error) => {
                    this.commentstamp.errors = error.response.data;
                });
        },
        newAbsence() {
            this.fetchData();
        },
        fetchEmployeeShift() {
            axios
                .get("/api/employeeshifts", {
                    params: {
                        employee_id: this.employee_id,
                        week: this.week,
                        year: this.varday.substring(0, 4),
                    },
                })
                .then((resp) => {
                    this.employeeshift = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        autofill(stamp) {
            let newStamp = this.unsavedList.find(item => item.uuid == stamp.uuid);

            newStamp.project_id = (this.projects || []).find(item => item.id == (this.employeeshift ? this.employeeshift.project_id : 0))?.id || 0;
            newStamp.location_id = this.employee.location_id || 0;
            if (this.varday) {
                newStamp.intime = formatDateTime(new Date(this.varday + 'T00:00:00'));
                // newStamp.outtime = formatDateTime(new Date(this.varday + 'T00:00:00'));
            } else {
                newStamp.intime = formatDateTime(new Date());
                // newStamp.outtime = formatDateTime(new Date());
            }
        },
        handleRowBlur(event, index, list) {            
            const row = event.target.closest('tr');
            const relatedTarget = event.relatedTarget;
            
            if (!relatedTarget || !row.contains(relatedTarget)) {
                this.changeInRow(index, list);
            }
        },
        autofillField(field, stamp) {
            if (!stamp) return "";

            const newStamp = this.stamps.find(item => item.id == stamp.id) || this.unsavedList.find(item => item.uuid == stamp.uuid);

            if (field === 'intime') {
                if (!stamp.intime) {
                    newStamp.intime = formatDateTime(new Date(this.varday + 'T00:00:00'));
                }
            }

            else if (field === 'outtime') {
                if (!stamp.outtime) {
                    newStamp.outtime = formatDateTime(new Date(this.varday + 'T00:00:00'));
                }
            }

            else if (field === 'project') {
                if (!stamp.project_id || stamp.project_id == 0) {
                    const project = (this.projects || []).find(item => item.id == (this.employeeshift ? this.employeeshift.project_id : 0));
                    newStamp.project_id = project ? project.id : 0;
                }
            }

            else if (field === 'location') {
                if (!stamp.location_id || stamp.location_id == 0) {
                    newStamp.location_id = this.employee.location_id || 0;
                }
            }
        },
    },
};
</script>

<style scoped></style>
